export default __webpack_public_path__ + "static/media/36I-102612_-17014_0.59ae06a8.jpg";